export const classes = (theme) => ({
  title: {
    color: theme.palette.primary.main,
    fontWeight: 400,
  },
  mainContainer: {
    paddingTop: 10,
    paddingLeft: 20,
    paddingRight: 35,
    paddingBottom: 30,
  },
  root: {
    "& .MuiInputBase-input": {
      paddingTop: 4,
      paddingBottom: 1,
    },
  },
  mainGrid: {
    padding: 20,
    marginTop: 20,
  },
  subTitle2: {
    paddingTop: 10,
    paddingBottom: 10,
  },
  padding: {
    paddingTop: 20,
    paddingleft: 20,
  },
  employeeId: {
    paddingRight: 5,
  },
  empFormControl: {
    width: 112,
    paddingLeft: 6,
  },
  nameControl: {
    marginLeft: 12,
  },
  formControl: {
    minWidth: 235,
    marginLeft: 12,
  },
  cbControl: {
    paddingTop: 10,
  },
  button: {
    minWidth: 131,
  },
  formHelperText: {
    fontSize: 10,
    paddingLeft: 6,
  },
  color: {
    color: theme.grey,
  },
  name: {
    color: theme.grey,
  },
  userAccessControl: {
    marginLeft: 15,
    width: "90%",
  },
  userControl: {
    paddingBottom: 15,
    flexDirection: "row",
  },
  container: {
    padding: theme.spacing(3),
    flexGrow: 1,
  },
  paper: {
    width: "100%",
    height: "100%",
  },
  actions: {
    marginTop: theme.spacing(2),
  },
});
